import React from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import { DatePickerWithInput } from "components"
import classes from "./OfsDate.module.scss"

const OfsDate = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleChangeDate = (range) => {
    setForm(prev => ({
      ...prev,
      fromDate: range[0] || "",
      toDate: range[1] || ""
    }))
  }

  return (
    <div className={classes["container"]}>
      <DatePickerWithInput
        isClearable
        type="rangeDatePicker"
        label={t("بازه_زمانی")}
        maxDate={moment().toISOString()}
        onChange={handleChangeDate}
        range={form.fromDate ? [form.fromDate, form.toDate] : []}
      />
    </div>
  )
}

export default OfsDate